import React from "react";
import styled from "styled-components";
import IcomoonIcon from "@icons/IcomoonIcon";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.65);
  border-radius: 4px;
  z-index: 1001;
`;

const SpinnerContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translate(-50%, -50%);
  z-index: 1010;
`;

const LoadingText = styled.div`
  margin-top: 8px;
  font-size: 13px;
  color: #5a7a9a;
  white-space: nowrap;
`;

interface TableLoaderSpinnerProps {
  loading?: boolean;
}

const TableLoaderSpinner: React.FC<TableLoaderSpinnerProps> = ({
  loading = false,
}) => {
  if (!loading) return null;

  return (
    <>
      <Overlay />
      <SpinnerContent>
        <IcomoonIcon
          icon="spinner9"
          iconClassName="icon-spin"
          color="#75b9e6"
          size={36}
        />
        <LoadingText>{translate(LanguageKey.loading_key)}</LoadingText>
      </SpinnerContent>
    </>
  );
};

export default TableLoaderSpinner;
